import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import classNames from 'classnames';

import { getNavigationItems } from './store';

import { NavigationItem } from './types';

import './navigation.scss';
import { getDriverPermissions } from '../../profile/store';
import {
  getUnsavedHOSExceptionsEditsPresent,
  getUnsavedHOSLogEditsPresent,
  setEditingStatus,
  setInsertingDutyStatus,
  setIsAddingException,
  setUnsavedHOSExceptionsEditsPresent,
  setUnsavedHOSLogEditsPresent,
} from 'src/features/hosLogs/store';
import HosLogEditModal from 'src/components/HOSLogEditModal/HosLogEditModal';

export interface Props {
  items?: NavigationItem[];
  onClick: (isMobile?: boolean) => void;
}

export const Navigation: React.FC<Props> = ({ onClick }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  useEffect(() => {
    if (isMobile) {
      document.body.style.overflow = 'hidden';
      return () => {
        document.body.style.overflow = 'auto';
      };
    }
  }, []);

  const navigationItems = useSelector(getNavigationItems);

  const driverPermissions = useSelector(getDriverPermissions);

  const pathname = useLocation().pathname;

  const unsavedHOSLogDutyChangesPresent = useSelector(getUnsavedHOSLogEditsPresent);

  const unsavedHOSExceptionChangesPresent = useSelector(getUnsavedHOSExceptionsEditsPresent);

  const [showLogEditModal, setShowLogEditModal] = useState(false);

  const discardDutyEdits = () => {
    dispatch(setEditingStatus(undefined));
    dispatch(setInsertingDutyStatus(false));
    dispatch(setUnsavedHOSLogEditsPresent(false));
  };

  const discardExceptionEdits = () => {
    dispatch(setUnsavedHOSExceptionsEditsPresent(false));
    dispatch(setIsAddingException(false));
  };

  const performClickAction = (isMobile: boolean, goTo = '') => {
    if (unsavedHOSExceptionChangesPresent) {
      setShowLogEditModal(true);
      return;
    }
    if (unsavedHOSLogDutyChangesPresent) {
      setShowLogEditModal(true);
      return;
    }
    discardDutyEdits();
    discardExceptionEdits();
    history.push(goTo);
    onClick(isMobile);
    hideModal();
  };

  const discardAll = () => {
    discardDutyEdits();
    discardExceptionEdits();
    hideModal();
    history.push('/hos-logs');
  };

  const hideModal = () => {
    setShowLogEditModal(false);
  };

  return (
    <>
      {showLogEditModal && (
        <HosLogEditModal
          title="Leave Page"
          message="All changes will be lost. Do you want to proceed?"
          proceedButtonText="Discard Changes"
          proceedButtonFn={() => {
            discardAll();
          }}
          undoButtonText="Cancel"
          undoButtonFn={hideModal}
        />
      )}
      <div className={classNames('navigation', { 'is-desktop': !isMobile })}>
        {isMobile && <div className="navigation-backdrop"></div>}
        <div className="navigation-menu">
          <div className="navigation-content">
            <div className="navigation-buttons">
              {navigationItems.map(item =>
                !item?.permissions ||
                (item?.permissions &&
                  driverPermissions.some(permission => item?.permissions?.includes(permission))) ? (
                  !isMobile && item.mobileOnly ? null : (
                    <a
                      key={item.header}
                      className={classNames({
                        'is-active': pathname.indexOf(item.linkTo) !== -1 && !isMobile,
                      })}
                      onClick={() => performClickAction(isMobile, item.linkTo)}
                    >
                      <div className="navigation-box">
                        <div className="navigation-span">
                          <span className="main-text">{item.header}</span>
                          <span className="secondary-text">{item.description}</span>
                        </div>
                      </div>
                    </a>
                  )
                ) : null,
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Navigation;
